/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { useEffect, useRef, useState } from 'react';
import {
    array, object, bool,
    func,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import ReactHtmlParser from 'react-html-parser';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIosTwoTone';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIosTwoTone';
import Slider from 'react-slick';
import Media from 'react-media';
import { useDispatch, useSelector } from 'react-redux';
import AddOnItemListV3 from './AddOnItemListV3';
import { getSelectedInlineAddons } from '../../../../../../../state/ducks/App/App-Selectors';
import SelectedAddOnV3 from './SelectedAddOnV3';
import { setSelectedInlineAddons } from '../../../../../../../state/ducks/App/App-Actions';
import WineInformation from './WineInformation';

const styles = (theme) => ({
    addOnButton: {
        display: '-webkit-box',
        padding: '0px 0px 12px 0px',
        overflowY: 'auto',
        cursor: 'pointer',
        '&::-webkit-scrollbar-thumb': {
            borderRadius: '10px',
            backgroundColor: 'rgba(156, 156, 156, 1)',  // scroll bar color
        },
        '&::-webkit-scrollbar': {  /* Works on scrollbar for Chrome, Safari and Opera */
            height: '3px',
            backgroundColor: 'transparent',
        },
        '&::-webkit-scrollbar-track': {
            borderRadius: '10px',
            backgroundColor: 'transparent',
        },
    },
    addonNames: {
        fontSize: '0.875rem',
        padding: '9px 12px',
        borderRadius: '50px',
        background: theme.palette.headerColor || '#E8F1ED',
        marginRight: '12px',
    },
    selectedAddon: {
        fontSize: '0.875rem',
        padding: '9px 12px',
        borderRadius: '50px',
        background: theme.palette.black || '#000000',
        marginRight: '12px',
        color: theme.palette.white || '#ffffff',
    },
    sliderContainer: {
        position: 'relative',
        width: '100%',
        '&:hover': {
            '& .slick-next': {
                display: 'block !important',
                boxShadow: '2px 2px 4px rgb(47 47 47 / 15%)',
            },
            '& .slick-prev': {
                display: 'block !important',
                boxShadow: '2px 2px 4px rgb(47 47 47 / 15%)',
            },
            '& .slick-disabled': {
                display: 'none !important',
            },
        },
        '& .slick-list': {
            overflow: 'hidden',
            margin: '0 auto',
            width: '100%',
            '&::-webkit-scrollbar-thumb': {
                borderRadius: '10px',
                backgroundColor: 'rgba(156, 156, 156, 1)',  // scroll bar color
            },
            '&::-webkit-scrollbar': {  /* Works on scrollbar for Chrome, Safari and Opera */
                height: '3px',
                backgroundColor: 'transparent',
            },
            '&::-webkit-scrollbar-track': {
                borderRadius: '10px',
                backgroundColor: 'transparent',
            },

        },
        '& .slick-slide': {
            display: 'inline-block',
            padding: 3,
            verticalAlign: 'top',
        },
        '& .slick-next': {
            right: '1%',
            borderRadius: '50%',
            width: '30px',
            background: theme.palette.headerColor || '#E8F1ED',
            display: 'none !important',
            transform: 'translate(0,-50%)',
            cursor: 'pointer',
            outline: 0,
            fontSize: '0px',
            lineHeight: '0px',
            top: '38%',
            height: '30px',
            position: 'absolute',
            '& svg': {
                width: '0.7em',
                position: 'absolute',
                right: '15%',
                top: '1px',
            },
        },
        '& .slick-prev': {
            left: '1%',
            borderRadius: '50%',
            zIndex: 9,
            width: '30px',
            background: theme.palette.headerColor || '#E8F1ED',
            display: 'none !important',
            transform: 'translate(0,-50%)',
            cursor: 'pointer',
            outline: 0,
            fontSize: '0px',
            lineHeight: '0px',
            top: '38%',
            height: '30px',
            position: 'absolute',
            '& svg': {
                width: '0.7em',
                position: 'absolute',
                right: '16%',
                top: '2px',
            },
        },
    },
    addonInnerContainer: {
        width: '33%',
        minWidth: '130px',
        padding: '5px',
    },
    addonContainer: {
        display: 'flex',
        overflowY: 'auto',
        padding: '0px 0px 8px',
        '&::-webkit-scrollbar-thumb': {
            borderRadius: '10px',
            backgroundColor: 'rgba(156, 156, 156, 1)',  // scroll bar color
        },
        '&::-webkit-scrollbar': {  /* Works on scrollbar for Chrome, Safari and Opera */
            height: '3px',
            backgroundColor: 'transparent',
        },
        '&::-webkit-scrollbar-track': {
            borderRadius: '10px',
            backgroundColor: 'transparent',
        },
    },
    container: {
        paddingTop: '12px',
        position: 'relative',
        '@media screen and (max-width: 1024px)': {
            overflow: 'scroll',
            position: 'relative',
        },
    },
    errorMessage: {
        color: theme.palette.cms?.errorMessage || '#DF3030',
        fontWeight: 400,
        fontSize: '0.875rem',
        display: 'flex',
        alignItems: 'center',
        lineHeight: '18px',
        bottom: '0px',
        gridArea: 'errorMessage',
        '@media screen and (max-width: 1024px)': {
            bottom: '12px',
        },
    },
    errorImage: {
        width: '16px',
        marginRight: '3px',
    },
    sliderWrapper: {
        '& .slick-track': {
            display: 'flex',
        },
        '& .slick-slide': {
            padding: 0,
            marginRight: '16px',
        },
        '& $addonInnerContainer': {
            [theme.breakpoints.down('600')]: {
                width: '33%',
                minWidth: '107px',
                padding: '0px',
                marginRight: '16px',
            },
        },
    },
    addBtnWrapper: {
        '& $selectedAddon , $addonNames': {
            padding: '7px 20px',
            fontSize: '14px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            lineHeight: '20px',
            letterSpacing: '0.5px',
            border: 'inherit',
            [theme.breakpoints.down('600')]: {
                fontSize: '12px',
                lineHeight: '16px',
                marginRight: '8px',
            },
        },
        '& $addonNames': {
            background: '#F5F5F5',
        },
    },
    errorMessageContainer: {
        padding: '10px 0px 0px 7px',
    },
    wineInfoContainer: {
        display: 'grid',
        gridTemplateAreas: '"errorMessage wineInfo"',
        position: 'relative',
        marginTop: '5px',
        '@media screen and (max-width: 900px)': {
            gridTemplateAreas: '"wineInfo" "errorMessage"',
            gridAutoColumns: '100%',
        },
        '& $errorMessage': {
            padding: '0px',
        },
    },
    wineInfo: {
        gridArea: 'wineInfo',
        fontSize: '0.875rem',
        lineHeight: '18px',
        textAlign: 'right',
        textDecoration: 'underline',
        cursor: 'pointer',
        '@media screen and (max-width: 900px)': {
            textAlign: 'left',
            padding: '.5rem 0',
        },
    },
});

const AddonV3List =  (
    {
        addonGroups, classes, isPdpRedesignEnabled, showAddons, addOn,
    },
) => {
    const [error, setError] = useState(false);
    const sliderRef = useRef();
    const scrollRef = useRef();
    const [addonSelect, setAddonSelect] = useState([]);

    useEffect(() => {
        if (sliderRef?.current) {
            sliderRef.current.slickGoTo(0);
        }
        if (typeof window !== 'undefined' && scrollRef.current?.scrollTo) {
            const offsetLeft = scrollRef.current?.offsetLeft;
            const scrollLeft = scrollRef.current?.scrollLeft;
            if ((offsetLeft < scrollLeft)) {
                scrollRef.current.scrollTo({
                    top: 0,
                    left: offsetLeft,
                });
            }
        }
    }, [addOn]);

    const setSelectedAddOns = useDispatch();

    useEffect(() => {
        setSelectedAddOns(setSelectedInlineAddons([]));
    }, []);
    const selectAddons = useSelector(getSelectedInlineAddons);
    const handleQuantity = () => {
        const qtyArray = (selectAddons || []).map((addon) => addon.qty);
        return (qtyArray || []).reduce((a, b) => a + b, 0);
    };

    const handleAddOnChange = (option, type = 'add') => {
        const totalSelectedAddons = ((selectAddons || []).map((addon) => addon.qty) || [0]).reduce((a, b) => a + b, 0);
        if (type === 'add' && totalSelectedAddons < addOn?.maxAllowedAddons) {
            setSelectedAddOns(setSelectedInlineAddons([...selectAddons]));
        }
        if (type === 'remove' && totalSelectedAddons <= addOn?.maxAllowedAddons) {
            setSelectedAddOns(setSelectedInlineAddons([...selectAddons]));
        }
        const selectedAddon = option;
        const addons = selectAddons || [];
        const findSelectedAddOn = addons?.findIndex((addon) => addon?.partNumber === option?.partNumber);
        if (findSelectedAddOn < 0 && type === 'add') {
            selectedAddon.qty = 1;
        }
        if (findSelectedAddOn >= 0) {
            if (type === 'add' && (selectedAddon.qty || 1) < addOn?.maxAllowedAddons) {
                selectedAddon.qty = (addons[findSelectedAddOn].qty || 0) + 1;
            } else {
                selectedAddon.qty = (addons[findSelectedAddOn].qty || 0) - 1;
            }
        }

        if (selectedAddon) {
            if (type === 'add' && totalSelectedAddons < addOn?.maxAllowedAddons) {
                const alreadySelected = addons?.findIndex((addon) => addon?.partNumber === selectedAddon?.partNumber);
                if (alreadySelected >= 0) {
                    addons.splice(alreadySelected, 1);
                }
                addons.push(selectedAddon);
                setSelectedAddOns(setSelectedInlineAddons(addons));
            } else if (type === 'remove') {
                const decrementAddon = addons.findIndex((addon) => addon?.partNumber === option?.partNumber);
                if (decrementAddon >= 0 && selectedAddon?.qty === 0) {
                    addons.splice(findSelectedAddOn, 1);
                }
                if (selectedAddon?.qty > 0) {
                    addons[decrementAddon].qty = selectedAddon.qty;
                }
                setSelectedAddOns(setSelectedInlineAddons(addons));
                setError(false);
            }
        }
    };
    const handleIncrement = (item) => {
        if (addonSelect.length < addOn?.maxAllowedAddons) {
            setAddonSelect([...addonSelect, item]);
        }
        const totalSelectedAddons = ((selectAddons || []).map((addon) => addon.qty) || [0]).reduce((a, b) => a + b, 0);
        if (totalSelectedAddons < addOn?.maxAllowedAddons) {
            handleAddOnChange(item, 'add');
        } else {
            setError(true);
        }
    };

    const handleDecrement = (item) => {
        const remove = [...addonSelect];
        const removeAddon = remove?.findIndex((addonRemove) => addonRemove.id === item.id);
        if (addonSelect?.length > 0) {
            remove.splice(removeAddon, 1);
            setAddonSelect(remove);
        }
        if (selectAddons?.length > 0) {
            handleAddOnChange(item, 'remove');
        }
    };

    const handleCount = (item) => {
        let count = '';
        selectAddons.map((selectedItem) => {
            if (selectedItem?.id === item?.id) {
                count =  selectedItem.qty;
            }
        });
        return count;
    };
    return (
        <>
            <div className={`${classes.addOnButton} ${isPdpRedesignEnabled ? classes.addBtnWrapper : ''}`}>
                {(addonGroups || []).map((group) => (
                    <>
                        <button
                            className={addOn?.name === group?.name ? classes.selectedAddon : classes.addonNames}
                            type="button"
                            onClick={() => showAddons(group)}
                            onKeyDown={() => showAddons(group)}
                            data-testId={group.name}
                        >
                            {ReactHtmlParser(group.name)} ({group.addons.length})
                        </button>

                    </>
                ))}

            </div>
            {addOn?.addons?.length && (
                <div>
                    <div className={`${classes.container} ${isPdpRedesignEnabled ? classes.sliderWrapper : ''}`}>
                        <Media query="(min-width: 1025px)">
                            {(matches) => (matches
                                ? (
                                    <Slider
                                        className={error ? `${classes.sliderContainer} ${classes.errorDesktopContainer}` : classes.sliderContainer}
                                        dots={false}
                                        infinite={false}
                                        speed={500}
                                        slidesToShow={isPdpRedesignEnabled ? 3.9 : 4.5}
                                        slidesToScroll={2}
                                        arrows
                                        ref={sliderRef}
                                        nextArrow={<div><ArrowForwardIosIcon /></div>}
                                        prevArrow={<div><ArrowBackIosIcon /></div>}
                                    >
                                        {addOn.addons.map((options) => (
                                            <AddOnItemListV3
                                                options={options}
                                                handleQuantity={handleQuantity()}
                                                error={error}
                                                handleDecrement={handleDecrement}
                                                handleIncrement={handleIncrement}
                                                handleCount={handleCount}
                                                isPdpRedesignEnabled={isPdpRedesignEnabled}
                                            />
                                        ))}

                                    </Slider>
                                )
                                : (
                                    <div className={error ? `${classes.addonContainer} ${classes.errorContainer}` : classes.addonContainer}  ref={scrollRef}>
                                        {addOn.addons.map((option) => (
                                            <div className={classes.addonInnerContainer}>
                                                <AddOnItemListV3
                                                    options={option}
                                                    handleQuantity={handleQuantity()}
                                                    error={error}
                                                    handleDecrement={handleDecrement}
                                                    handleIncrement={handleIncrement}
                                                    handleCount={handleCount}
                                                    isPdpRedesignEnabled={isPdpRedesignEnabled}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                )
                            )}
                        </Media>
                        <div className={isPdpRedesignEnabled ? classes.wineInfoContainer : classes.errorMessageContainer}>
                            {error && (
                                <div className={classes.errorMessage}>
                                    {isPdpRedesignEnabled ? <div>You’ve reached the maximum number of extras</div> : <><img className={classes.errorImage} src="https://images.contentstack.io/v3/assets/blt89dbf1c763ec00a6/blt1409d5850dcc9be8/632bf208dbb41c0cdadc86c5/circle.svg?auto=webp" alt="Error Message" /> <div> You have added the maximum of Extras allowed</div></>}
                                </div>
                            )}
                            {isPdpRedesignEnabled && <WineInformation classes={classes} selectAddons={selectAddons} />}
                        </div>
                    </div>
                    {!isPdpRedesignEnabled
                    && (
                        <SelectedAddOnV3
                            selectAddons={addonSelect}
                            handleQuantity={handleQuantity()}
                            handleDecrement={handleDecrement}
                            handleIncrement={handleIncrement}
                            handleCount={handleCount}
                            error={error}
                            maxAddons={addOn?.maxAllowedAddons}
                        />
                    )}
                </div>
            )}
        </>
    );
};

AddonV3List.propTypes = {
    addonGroups: array.isRequired,
    classes: object.isRequired,
    isPdpRedesignEnabled: bool,
    showAddons: func,
    addOn: object,
};
AddonV3List.defaultProps = {
    isPdpRedesignEnabled: false,
    showAddons: () => {},
    addOn: {},
};

export default (withStyles(styles)(AddonV3List));
